
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout class="flex md12 justify-end" row wrap style="position: absolute; right: 50px; top: 20px">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>

            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <object id="svg-fig" :data="svgUrl" type="image/svg+xml" width="100%" height="100%"></object>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "CurrentStatus",
  mixins: [mediator],

  mounted() {
    this.currentSerialNo = this.publisher("GetSelectSerial", []);
    if (!this.currentSerialNo) return;

    this.setSvgUrl();
    this.viewSVG();
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      data: null,
      title: $t("CurrentStatus.Item"),
      $fig: null,
      isAutoUpdate: false,
      countDownTimer: 10,
      svgUrl: ""
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;

      this.viewSVG();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.viewSVG();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    viewSVG() {
      let vm = this;
      const serialNo = vm.axios
        .get(`${vm.$root.url}/Customer/CurrentStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            serialNo: vm.publisher("GetSelectSerial", [])
          }
        })
        .then(response => {
          vm.data = response.data;
          this.$fig = $(document.getElementById("svg-fig").contentDocument);
          this.setHeader();
          this.setTotal();
          this.setRelay();
          this.setError();
          this.setTemperature();
          this.setBatteries();
          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    setHeader() {
      let $status_offline = this.$fig.find("#status_offline");
      if (this.data.onOffStatus === "ON-LINE") {
        $status_offline.css("display", "none");
      } else {
        $status_offline.css("display", "inline");
      }
      this.$fig.find("#txt_serial").text(this.data.serialNo);
      this.$fig
        .find("#txt_date")
        .text(moment(this.data.measureTm).format("YYYY/MM/DD HH:mm:ss"));
      this.$fig.find("#txt_version").text(this.data.version);
    },
    setTotal() {
      this.$fig.find("#txt_current").text(`${this.data.totalCurrent}A`);
      this.$fig.find("#txt_voltage").text(`${this.data.totalVolt}V`);
      this.$fig.find("#txt_soc").text(this.data.soc);
      this.$fig.find("#txt_soh").text(this.data.soh);
    },
    setRelay() {
      this.changeRelay(
        "#relay_on_01",
        "#relay_01 path",
        this.data.dischargeRelay
      );
      this.changeRelay("#relay_on_02", "#relay_02 path", this.data.chargeRelay);
      this.changeRelay("#relay_on_03", "#relay_03 path", this.data.fanRelay);
      this.changeRelay("#relay_on_04", "#relay_04 path", this.data.heatRelay);
      this.changeRelay("#relay_on_05", "#relay_05 path", this.data.relay5);
      this.changeRelay("#relay_on_06", "#relay_06 path", this.data.relay6);
    },
    changeRelay(relay_on_id, relay_id, relay_value) {
      let $relay_on = this.$fig.find(relay_on_id);
      let $relay = this.$fig.find(relay_id);
      if (relay_value == "OFF") {
        $relay_on.css("display", "none");
        $relay.css("fill", "#000000");
      } else {
        $relay_on.css("display", "inline");
        $relay.css("fill", "#21993A");
      }
    },
    setError() {
      this.changeError("#error_on_01", "#error_01 path", this.data.curHI);
      this.changeError("#error_on_02", "#error_02 path", this.data.chgHI);
      this.changeError("#error_on_03", "#error_03 path", this.data.voltHI);
      this.changeError("#error_on_04", "#error_04 path", this.data.voltLo);
      this.changeError("#error_on_05", "#error_05 path", this.data.charger);
      this.changeError("#error_on_06", "#error_06 path", this.data.tempHi);
      this.changeError("#error_on_07", "#error_07 path", this.data.tempLo);
      this.changeError("#error_on_08", "#error_08 path", this.data.intErr);
      this.changeError("#error_on_09", "#error_09 path", this.data.comErr);
      this.$fig.find("#txt_error").text(this.data.errCode);
    },
    changeError(error_on_id, error_id, error_value) {
      let $error_on = this.$fig.find(error_on_id);
      let $error = this.$fig.find(error_id);
      if (error_value == 0) {
        $error_on.css("display", "none");
        $error.css("fill", "#000000");
      } else {
        $error_on.css("display", "inline");
        $error.css("fill", "#E94D33");
      }
    },
    setTemperature() {
      this.showTempsAndText(this.$fig, this.data.temp1, "01");
      this.showTempsAndText(this.$fig, this.data.temp2, "02");
      this.showTempsAndText(this.$fig, this.data.temp3, "03");
      this.showTempsAndText(this.$fig, this.data.temp4, "04");
      this.showTempsAndText(this.$fig, this.data.temp5, "05");
      this.showTempsAndText(this.$fig, this.data.temp6, "06");
      this.showTempsAndText(this.$fig, this.data.temp7, "07");
      this.showTempsAndText(this.$fig, this.data.temp8, "08");
    },
    showTempsAndText($fig, temp, no) {
      if (temp !== null) {
        $fig.find(`#display_temp_${no}`).show();
        $fig.find(`#txt_temp_${no}`).show();
        $fig.find(`#shape_temp_${no}`).show();

        $fig.find(`#txt_temp_${no}`).text(`${temp}℃`);
        this.maskTemp(`#mask_temp_${no}`, temp);
      } else {
        $fig.find(`#display_temp_${no}`).hide();
        $fig.find(`#txt_temp_${no}`).hide();
        $fig.find(`#shape_temp_${no}`).hide();
      }
    },
    maskTemp(mask_id, temp_value) {
      let $mask = this.$fig.find(mask_id);
      let percent = 74.67 * (1 - (parseInt(temp_value) + 15) / 75);

      //数値を丸める
      if (percent > 74.67) {
        percent = 74.67;
      } else if (percent < 0) {
        percent = 0;
      }
      //実行
      //$mask.attr("height", percent);
      $mask.animate({ height: percent });
    },

    // セルのアニメーション変化はSOCの値を参照
    // 「showBatteriesAndText()」と「maskBatteries()」の引数にsocを追加しdata.socの値を参照できるようにした
    setBatteries() {
      let a = [
        this.data.cell01,
        this.data.cell02,
        this.data.cell03,
        this.data.cell04,
        this.data.cell05,
        this.data.cell06,
        this.data.cell07,
        this.data.cell08,
        this.data.cell09,
        this.data.cell10,
        this.data.cell11,
        this.data.cell12,
        this.data.cell13,
        this.data.cell14,
        this.data.cell15,
        this.data.cell16,
        this.data.cell17,
        this.data.cell18,
        this.data.cell19,
        this.data.cell20,
        this.data.cell21,
        this.data.cell22,
        this.data.cell23,
        this.data.cell24,
        this.data.cell25,
        this.data.cell26,
        this.data.cell27,
        this.data.cell28,
        this.data.cell29,
        this.data.cell30,
        this.data.cell31,
        this.data.cell32,
        this.data.cell33,
        this.data.cell34,
        this.data.cell35,
        this.data.cell36
      ];

      a = a.filter(v => v);
      const cell_max = Math.max.apply(null, a);
      const cell_min = Math.min.apply(null, a);

      for (let i = 1; i <= 36; i++) {
        let cellNo = i.toString().padStart(2, "0");
        this.showBatteriesAndText(
          this.$fig,
          this.data["cell" + cellNo],
          cellNo.toString(),
          cell_max,
          cell_min,
          this.data.soc
        );
      }
    },
    showBatteriesAndText($fig, cell, no, cell_max, cell_min, soc) {
      if (cell !== null) {
        $fig.find(`#display_cell_${no}`).show();
        $fig.find(`#txt_cell_${no}`).show();

        $fig.find(`#txt_cell_${no}`).text(`${cell}V`);
        this.maskBatteries(`#mask_cell_${no}`, cell, soc);
      } else {
        $fig.find(`#display_cell_${no}`).hide();
        $fig.find(`#txt_cell_${no}`).hide();
      }

      this.minmaxCellColor(`#shape_cell_${no}`, cell, cell_max, cell_min);
    },
    maskBatteries(mask_id, cell_value, soc) {
      let mask = this.$fig.find(mask_id);
      //以下はセル電圧での計算
      //let percent = 158 * (1 - (cell_value - 3.3) / 0.86);
      //以下はSOCの値で計算
      let percent = 158 * (1 - soc * 0.01);
      //数値を丸める
      if (percent > 158) {
        percent = 158;
      } else if (percent < 0) {
        percent = 0;
      }
      //実行
      //$mask.attr("width", percent);
      mask.animate({ width: percent });
    },
    minmaxCellColor(cell_id, cell_value, cell_max, cell_min) {
      let $color = this.$fig.find(cell_id);
      $color.css('display', 'inline');
      $color.css("fill", "#A0A0A0");

      if (cell_max != cell_min) {
        if (!cell_value) {
          $color.css("display", "none");
        } else if (cell_value == cell_max) {
          $color.css("fill", "#8DC2E6");
        } else if (cell_value == cell_min) {
          $color.css("fill", "#F08F90");
        }
      } else {
        if (!cell_value) {
          $color.css("display", "none");
        }
      }
    },
    setSvgUrl() {
      if (process.env.NODE_ENV === "development") {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "/static/svg/customer_jp.svg";
        } else if (locale.getCurrentLanguage() === 'en' || locale.getCurrentLanguage() === 'en-US') {
          this.svgUrl = "/static/svg/customer_en.svg";
        } else {
          this.svgUrl = "/static/svg/customer_ch.svg";
        }
      } else {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "static/svg/customer_jp.svg";
        } else if (locale.getCurrentLanguage() === 'en' || locale.getCurrentLanguage() === 'en-US') {
          this.svgUrl = "static/svg/customer_en.svg";
        } else{
          this.svgUrl = "static/svg/customer_ch.svg";
        }
      }
    }
  }
};
</script>

<style>
.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/router/Customer/CurrentStatus.vue